import FillRejectText from './FillRejectText.vue'
export default FillRejectText
